"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.otherIconOrders = exports.otherIcons = exports.blockIconOrders = exports.blockIcons = exports.markIconOrders = exports.markIcons = exports.localText = void 0;
var icons_1 = __importDefault(require("../../../../assets/icons"));
var Editor_static_1 = require("../Editor.static");
exports.localText = {
    tooltipBold: "Bold (".concat(Editor_static_1.modKey, "+B)"),
    tooltipBulletedList: "Bulleted list (".concat(Editor_static_1.modKey, "+Shift+8)"),
    tooltipItalic: "Italic (".concat(Editor_static_1.modKey, "+I)"),
    tooltipNumberedList: "Numbered list (".concat(Editor_static_1.modKey, "+Shift+7)"),
    tooltipRedo: "Redo (".concat(Editor_static_1.modKey, "+Y)"),
    tooltipStrikeThrough: "Strikethrough (".concat(Editor_static_1.modKey, "+Shift+S)"),
    tooltipUnderlined: "Underlined (".concat(Editor_static_1.modKey, "+U)"),
    tooltipUndo: "Undo (".concat(Editor_static_1.modKey, "+Z)"),
    tooltipLink: "Link (".concat(Editor_static_1.modKey, "+K)"),
    enterLink: 'Please enter a URL',
};
exports.markIcons = (_a = {},
    _a[Editor_static_1.MarkType.Bold] = { path: icons_1.default.bold, tooltip: exports.localText.tooltipBold },
    _a[Editor_static_1.MarkType.Italic] = { path: icons_1.default.italic, tooltip: exports.localText.tooltipItalic },
    _a[Editor_static_1.MarkType.StrikeThrough] = { path: icons_1.default.strikethrough, tooltip: exports.localText.tooltipStrikeThrough },
    _a[Editor_static_1.MarkType.Underline] = { path: icons_1.default.underlined, tooltip: exports.localText.tooltipUnderlined },
    _a);
exports.markIconOrders = (_b = {},
    _b[Editor_static_1.MarkType.Bold] = 1,
    _b[Editor_static_1.MarkType.Italic] = 2,
    _b[Editor_static_1.MarkType.StrikeThrough] = 4,
    _b[Editor_static_1.MarkType.Underline] = 3,
    _b);
exports.blockIcons = (_c = {},
    _c[Editor_static_1.ElementType.NumberedList] = { path: icons_1.default.ordered, tooltip: exports.localText.tooltipNumberedList },
    _c[Editor_static_1.ElementType.BulletedList] = { path: icons_1.default.unordered, tooltip: exports.localText.tooltipBulletedList },
    _c);
exports.blockIconOrders = (_d = {},
    _d[Editor_static_1.ElementType.NumberedList] = 2,
    _d[Editor_static_1.ElementType.BulletedList] = 1,
    _d);
exports.otherIcons = (_e = {},
    _e[Editor_static_1.ElementType.Link] = { path: icons_1.default.link, tooltip: exports.localText.tooltipLink },
    _e);
exports.otherIconOrders = (_f = {},
    _f[Editor_static_1.ElementType.Link] = 1,
    _f);
